// Masks
const COLLECTION_MASK = 0x3; // Bits 0-1
const DOMAIN_MASK = 0x3; // Bits 2-3
const TEST_TYPE_MASK = 0xf; // Bits 4-7
const CATEGORY_MASK = 0xff; // Bits 8-15

// Enums
export const COLLECTION = {
  SINGLE: 0,
  GROUP: 1,
};

export const DOMAIN = {
  LITERACY: 0,
  NUMERACY: 1,
};

export const TEST_TYPE = {
  READING: 1,
  LISTENING: 2,
  SPEAKING: 3,
  WRITING: 4,
};

export const CATEGORY = {
  LETTER: 1,
  WORD: 2,
  SENTENCE: 3,
  PASSAGE: 4,
  PICTURE: 8,
};

export const NUMERACY_CATEGORY = {
  DIGIT: 1,
  NUMBER: 2
};

// Getters
export const getCollection = (type) => type & COLLECTION_MASK;

export const getDomain = (type) => (type >> 2) & DOMAIN_MASK;

export const getTestType = (type) => (type >> 4) & TEST_TYPE_MASK;

export const getCategory = (type) => (type >> 8) & CATEGORY_MASK;

// Mode flags
export const hasComprehensionFlag = (type) => ((type >> 16) & 1) === 1;
export const hasHumanInputFlag = (type) => ((type >> 17) & 1) === 1;
export const hasModeFlag = (type, bit) => ((type >> bit) & 1) === 1;

// Common helpers
export const isReadingPassage = (type) =>
  getDomain(type) === DOMAIN.LITERACY &&
  getTestType(type) === TEST_TYPE.READING &&
  getCategory(type) === CATEGORY.PASSAGE;

export const isReadingLetter = (type) =>
  getDomain(type) === DOMAIN.LITERACY &&
  getTestType(type) === TEST_TYPE.READING &&
  getCategory(type) === CATEGORY.LETTER;

export const isReadingWord = (type) =>
  getDomain(type) === DOMAIN.LITERACY &&
  getTestType(type) === TEST_TYPE.READING &&
  getCategory(type) === CATEGORY.WORD;

export const isReadingNumber = (type) =>
  getDomain(type) === DOMAIN.NUMERACY &&
  getTestType(type) === TEST_TYPE.READING &&
  getCategory(type) === NUMERACY_CATEGORY.NUMBER;

export const isListeningPassage = (type) =>
  getDomain(type) === DOMAIN.LITERACY &&
  getTestType(type) === TEST_TYPE.LISTENING &&
  getCategory(type) === CATEGORY.PASSAGE;

export const isCollection = (type) =>
  getCollection(type) === COLLECTION.GROUP;